// extracted by mini-css-extract-plugin
module.exports = {"header-actions":"notification-card-header-actions_header-actions__puFXQ","header-actions__dismiss-button":"notification-card-header-actions_header-actions__dismiss-button__7uMwh"};